import React, { Fragment } from 'react';

function ResearchIntroPara() {
  return (
    <Fragment>
      As we build out the xMacroscope experiences we will observe how visitors interact with these
      experiences, surveying them about their experiences. This learning research will allow us to
      iterate on the technology and exhibit platform while expanding our understanding of data
      visualization literacy in the science center environment.
    </Fragment>
  );
}

export default ResearchIntroPara;
